import React, { useEffect, useState } from "react";
import { ReadModeContainer } from "./readMode.styled";
export default function ReadMode({ timeStampFea, timeStamp }) {
  const [word, setWord] = useState(1);
  const [doc, setDoc] = useState(null);

  function handleTimeStamp() {
    function filterWord(item) {
      return item.begin_time <= timeStamp && item.end_time >= timeStamp;
    }

    const result = doc.filter(filterWord);
    if (result?.length !== 0) {
      setWord(result[0]?.id);
    }
  }

  useEffect(() => {
    const newDoc = [];

    timeStampFea?.map?.((element, index) => {
      const obj = {
        ...element,
        id: index + 1,
      };
      newDoc.push(obj);
    });
    setDoc(newDoc);
  }, []);

  useEffect(() => {
    if (doc) {
      handleTimeStamp();
    }
  }, [timeStamp]);

  return (
    <ReadModeContainer>
      <div>
        {doc?.map((item, index) => {
          return (
            <span id={item.id} className={word === item.id && "active"}>
              {item.text}
            </span>
          );
        })}
      </div>
    </ReadModeContainer>
  );
}
